import { CourseType } from 'common-proptypes'
import CourseRenderer from './CourseRenderer.jsx'
import Empty from './Empty.jsx'

import styles from './CourseList.module.scss'

export default class CourseListRenderer extends React.PureComponent {
  static propTypes = {
    courses: PropTypes.arrayOf(CourseType).isRequired,
  }

  render() {
    const {
      courses,
    } = this.props
    const $courses = courses.map((course, i) => (
      <CourseRenderer
        key={course.id}
        className={cx({ even: i % 2, odd: !(i % 2) })}
        course={course}
      />
    ))
    return (
      <div className={styles.container}>
        <header>
          <h1>Assigned Courses</h1>
        </header>
        <div className={styles.courseList}>
          {$courses.length > 0 ? $courses : (
            <Empty
              className={styles.empty}
              key="empty"
            />
          )}
        </div>
      </div>
    )
  }
}
